import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { RecommendationService } from './../recommendation/recommendation.service';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { ResidentialService } from '../residential.service';
import { _ } from 'underscore';
import { PlatformLocation } from '@angular/common';
import { Renderer2,Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-congrats',
  templateUrl: './congrats.component.html',
  styleUrls: ['./congrats.component.css'],
})
export class CongratsComponent implements OnInit {
  orderNo;
  BKVDepositLink;
  // API Url
  averagePrice;
  IsShowPulsePowerRejectedMsg = false;
  PulsePowerRejectedMsg;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  avgbill;
  deviceWidth;
  url = environment.api_url;
  selectedProduct;
  providerContactInfo = [];
  providerContact;
  enableMessage = false;
  profileUrl;
  imagePath;
  // For social share
  // socialShareUrl = 'https://www.amazon.com/dp/1491999837/ref=cm_sw_r_tw_dp_U_x_JT7wCbVB1K0ZQ via @amazon';
  socialShareUrl =
    'https://www.honestgorilla.com/congrats/5c45858e189600425347b6a9';
  shareDescription =
    'I just signed up for energy using Honest Gorilla and they’re giving back a portion of my usage! ' +
    '@honestgorilla #lightofunity #light4light #electricity';
  metaTag = false;
  postResultConfirmationDetails: any;
  confirmationStatus: any;
  private confirmationStatusForCongratsDetails = {
    DepositNeeded: 'CONGRATS!<br />Well, almost…',
    PendingIdentityVerification: 'CONGRATS!<br />Well, almost…',
    Complete: "Congratulations!<br />You're all set!",
    Completed: "Congratulations!<br />You're all set!",
    PendingVerification: 'CONGRATS!<br />Well, almost…',
    Success: "Congratulations!<br />You're all set!",
  };
  hgAccountID: string;
  // selectedContactNumber: string;
  mailText: string;
  confirmationStatusText: boolean;
  private loadStatusPerEnergyProviders = {
    PulsePower: this.setRhythmEnergyConfirmationStatus.bind(this),
    NewPowerTexas: this.setRhythmEnergyConfirmationStatus.bind(this),
    ChangeEnergy4: this.set4ChangeEnergyConfirmationStatus.bind(this),
    GexaEnergy: this.setGEXAEnergyConfirmationStatus.bind(this),
    FrontierUtilities: this.setGEXAEnergyConfirmationStatus.bind(this),
    TexpoEnergy: this.setTexpoEnergyConfirmationStatus.bind(this),
    RhythmEnergy: this.setRhythmEnergyConfirmationStatus.bind(this),
    APGEEnergy: this.setRhythmEnergyConfirmationStatus.bind(this),
    ShellEnergy: this.setRhythmEnergyConfirmationStatus.bind(this),

  };
  loadConfirmatonTitlePerEnergyProviders = {
    PulsePower: this.postResultShellConfirmationStatus.bind(this),
    NewPowerTexas: this.postResultPulseConfirmationStatus.bind(this),
    ChangeEnergy4: this.postResultSuccessConfirmationStatus.bind(this),
    GexaEnergy: this.postResultSuccessConfirmationStatus.bind(this),
    FrontierUtilities: this.postResultSuccessConfirmationStatus.bind(this),
    TexpoEnergy: this.postResultTexpoConfirmationStatus.bind(this),
    ChariotEnergy: this.postResultChariotConfirmationStatus.bind(this),
    RhythmEnergy: this.postResultChariotConfirmationStatus.bind(this),
    BKVEnergy: this.postResultBKVConfirmationStatus.bind(this),
    APGEEnergy: this.postResultChariotConfirmationStatus.bind(this),
    ShellEnergy: this.postResultShellConfirmationStatus.bind(this),
  };
  CEResponse: any;
  fullText = false;
  partialText = true;
  ESIID: string;
  newFormattedAddress: string;
  customerName: string;
  showAll: boolean = false;

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private recommendationService: RecommendationService,
    private router: Router,
    private title: Title,
    private residentialService: ResidentialService,
    private meta: Meta,
    private location: PlatformLocation
  ) {
    sessionStorage.removeItem('userObj');
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.mailText = `mailto:abc@abc.com?subject=files&body=${this.selectedProduct.providerEmail}`;
    this.residentialService.getProviderContactInfo().subscribe((res: any) => {
      const result = JSON.stringify(res);
      this.providerContactInfo = JSON.parse(result);
    });

    this.imagePath = 'assets/images/gorillanewImage.gif';

    this.deviceWidth = this.residentialService.deviceWidth;
    this.averagePrice =
      Number(this.selectedProduct.new_tier.ave_price_per_KWH) * 100;
    this.t1_avg_charge = (
      Number(this.selectedProduct.tier[0].avg_charge) * 100
    ).toFixed(1);
    this.t2_avg_charge = (
      Number(this.selectedProduct.tier[1].avg_charge) * 100
    ).toFixed(1);
    this.t3_avg_charge = (
      Number(this.selectedProduct.tier[2].avg_charge) * 100
    ).toFixed(1);
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.avgbill = Math.round(this.selectedProduct.new_tier.ave_monthly_bill);
    var postObj = JSON.parse(sessionStorage.getItem('PostObject'));
  }

  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    // append to head of document
    
    document.getElementsByTagName('head')[0].appendChild(node); 

    let script = this._renderer2.createElement('script');
    script.text = `
    window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-10999221905'); 
    `;
    document.getElementsByTagName('head')[0].appendChild(script); 

    let script_ = this._renderer2.createElement('script');
    script_.text = `
     gtag('event', 'conversion', {'send_to': 'AW-10999221905/jj36CJ_9xYAYEJGd6_wo'}); 
    `;

    document.getElementsByTagName('head')[0].appendChild(script_); 
  }
  back() {
    this.router.navigate([
      // 'recommendation/compare-product',
      // this.recommendationService.hg_accountId,
      'congrats' , this.hgAccountID
    ]);
  }
  ngOnInit() {
    this.removeScript();
    //history.pushState(null, '');
    if(environment.production)
    {
      this.loadScript();
    }
    this.location.onPopState(() => {
      history.forward();
      this.back();
    });
    this.hgAccountID = window.location.href.split('/').pop();
    this.customerName = sessionStorage.getItem('customerName');
    this.ESIID = sessionStorage.getItem('esiidValue').split('-')[0];
    this.newFormattedAddress = sessionStorage
      .getItem('esiidValue')
      .split('-')[1];
    // this.selectedContactNumber = `tel:${this.selectedProduct.providerContact}`;
    this.setMetaTab();
    this.loadStatusPerEnergyProviders[
      this.renameEnergyProviderName(
        this.selectedProduct.energy_provider.replace(/\s/g, '')
      )
    ]();
    //Disable the Browser back button in pre-congrats page.

    var stateData = { data: "State data" };
    var pageTitle = "Page Title";
    var urlToRemove = "/recommendation/compare-product/"+ this.hgAccountID;
    
    window.history.replaceState(stateData, pageTitle, '/congrats/' + this.hgAccountID);

     history.pushState(null, null, location.href);
    // window.onpopstate = function () {
    //   debugger
    //   history.go(1);
    // };
  }

  selectedContactNumber() {
    return `tel:${this.selectedProduct.providerContact}`;
  }

  setMetaTab() {
    this.meta.updateTag({
      'og:description':
        'Honest Gorilla, Shop for Energy. Save with Confidence.',
      'og:url': 'https://www.honestgorilla.com',
      'og:image': 'https://www.honestgorilla.com/assets/images/congrats.svg',
      'fb:app_id': '447219326173194',
    });
  }

  renameEnergyProviderName(itemName: string) {
    return itemName === '4ChangeEnergy' ? `${itemName.slice(1)}4` : itemName;
  }

  setPulsePowerConfirmationStatus() {
    if (this.residentialService.setConfirmationStatusDetails === undefined) {
      this.assignConfirmationDetails();
    } else {
      this.postResultConfirmationDetails =
        this.residentialService.setConfirmationStatusDetails;
      this.checkPendingIdentityVerification();
      this.orderNo = this.assignConfirmationNumber();
    }
  }

  set4ChangeEnergyConfirmationStatus() {
    const postResult = this.residentialService.setConfirmationStatusDetails;
    this.orderNo = this.getEnrollmentResultAccountNumber(postResult);
    this.CEResponse = this.getEnrollmentResultResponseType(postResult);
  }

  setGEXAEnergyConfirmationStatus() {
    const postResult = this.residentialService.setConfirmationStatusDetails;
    this.orderNo = postResult.AccountNumber;
    this.CEResponse = postResult.RequestMessage;
  }

  setTexpoEnergyConfirmationStatus() {
    const postResult =
      this.residentialService.setConfirmationStatusDetails.Message;
    this.orderNo =
      this.residentialService.setConfirmationStatusDetails.AccountNumber;
  }
  setRhythmEnergyConfirmationStatus() {
    
    
    this.postResultConfirmationDetails =
        this.residentialService.setConfirmationStatusDetails;
    const postResult =
      this.residentialService.setConfirmationStatusDetails.Message;
    this.orderNo =
    this.postResultConfirmationDetails.ConfirmationNumber;
    this.postResultConfirmationDetails['ConfirmationStatus'] = this.residentialService.setConfirmationStatusDetails.webStatus

    if(this.residentialService.setConfirmationStatusDetails.reason == "Rejected" && (this.residentialService.setConfirmationStatusDetails.selectedProduct.energy_provider == "Pulse Power" || this.residentialService.setConfirmationStatusDetails.selectedProduct.energy_provider == "New Power Texas"))
    {
      this.PulsePowerRejectedMsg = this.residentialService.setConfirmationStatusDetails["RejectedMessage"];
      this.IsShowPulsePowerRejectedMsg = true;
    }
  }

  getEnrollmentResultResponseType(postResult) {
    return postResult &&
      postResult.CompleteCustomerEnrollmentResult === undefined
      ? postResult.EnrollCustomerResult.ResponseType
      : postResult.CompleteCustomerEnrollmentResult.ResponseType;
    // if (
    //   postResult &&
    //   postResult.CompleteCustomerEnrollmentResult === undefined
    // ) {
    //   return postResult.EnrollCustomerResult.ResponseType;
    // } else {
    //   return postResult.CompleteCustomerEnrollmentResult.ResponseType;
    // }
  }

  getEnrollmentResultAccountNumber(postResult) {
    return postResult &&
      postResult.CompleteCustomerEnrollmentResult === undefined
      ? postResult.EnrollCustomerResult.AccountNumber
      : postResult.CompleteCustomerEnrollmentResult.AccountNumber;
    // if (
    //   postResult &&
    //   postResult.CompleteCustomerEnrollmentResult === undefined
    // ) {
    //   return postResult.EnrollCustomerResult.AccountNumber;
    // } else {
    //   return postResult.CompleteCustomerEnrollmentResult.AccountNumber;
    // }
  }

  assignConfirmationDetails() {
    const userObj = {
      hgAccountId: this.hgAccountID,
    };

    this.residentialService
      .getDepositPendingStatus(userObj)
      .subscribe((res: any) => {
        this.residentialService.setConfirmationStatusDetails = res[0];
        this.postResultConfirmationDetails =
          this.residentialService.setConfirmationStatusDetails;
        this.orderNo = this.assignConfirmationNumber();
        this.checkPendingIdentityVerification();
      });
  }

  assignConfirmationNumber(): string {
    return this.postResultConfirmationDetails.ConfirmationNumber;
  }

  ngAfterContentChecked(): void {
    setInterval(() => {
      this.imagePath = 'assets/images/congrats.svg';
    }, 10000);
  }

  mailMe(mail) {
    this.mailText = `mailto:${mail}?subject=Hi&body=Hi`;
    window.location.href = this.mailText;
  }

  next() {
    //history.pushState(null, '');
    //history.pushState(null, null, 'congrats/'+ this.hgAccountID);
   
    history.pushState(null, '', document.URL);
    //history.pushState(null, null, 'congrats/'+ this.hgAccountID);
    //history.pushState(null, null, 'user-settings/'+this.hgAccountID);

    this.router.navigate(['user-settings', this.hgAccountID]);
  }

  checkPendingIdentityVerification() {
    if (this.postResultConfirmationDetails.ConfirmationStatus !== undefined) {
      this.confirmationStatusText =
        (this.selectedProduct.energy_provider === 'Pulse Power' ||
          this.selectedProduct.energy_provider === 'New Power Texas') &&
        (this.postResultConfirmationDetails.ConfirmationStatus ===
          'Pending Identity Verification' ||
          this.postResultConfirmationDetails.ConfirmationStatus ===
            'Pending Verification');
    }
  }

  postResultPulseConfirmationStatus() {
    const status =
      this.postResultConfirmationDetails.ConfirmationStatus.replace(/\s/g, '');
    return this.confirmationStatusForCongratsDetails[
      status === 'PendingDeposit'
        //? this.postResultConfirmationDetails.Status
        ? "DepositNeeded"
        : status
    ];
  }

  postResultTexpoConfirmationStatus() {
    let res = this.residentialService.setConfirmationStatusDetails;
    let depAmount = res.Message.split('<br />')[7].search('$');
    depAmount = res.Message.split('<br />')[7].substr(depAmount);
  }

  postResultChariotConfirmationStatus() {
    
      this.orderNo =
      this.residentialService.setConfirmationStatusDetails.ConfirmationNumber;
    
    }

    postResultShellConfirmationStatus() {
    
      this.postResultConfirmationDetails =
      this.residentialService.setConfirmationStatusDetails;
      this.orderNo =
      this.residentialService.setConfirmationStatusDetails.ConfirmationNumber;
      this.postResultConfirmationDetails['ConfirmationStatus'] =
      this.residentialService.setConfirmationStatusDetails.webStatus;
    
    }

    postResultBKVConfirmationStatus()
    {
      
      this.orderNo =
      this.residentialService.setConfirmationStatusDetails.ConfirmationNumber;
      this.BKVDepositLink = this.residentialService.completeCustomerEnrollmentPostObject['PaymentLink'];
      

    }

  postResultSuccessConfirmationStatus() {
    return this.confirmationStatusForCongratsDetails[
      this.CEResponse.replace(/\s/g, '')
    ];
  }

  setConfirmationStatusPerEnergyProviders() {
    return this.loadConfirmatonTitlePerEnergyProviders[
      this.renameEnergyProviderName(
        this.selectedProduct.energy_provider.replace(/\s/g, '')
      )
    ]();
  }

  getPostResultConfirmationDetails() {
    return (
      this.postResultConfirmationDetails !== undefined &&
      this.postResultConfirmationDetails.ConfirmationStatus !== undefined &&
      (this.postResultConfirmationDetails.ConfirmationStatus ===
        'Pending Identity Verification' ||
        this.postResultConfirmationDetails.ConfirmationStatus ===
          'Pending Verification')
    );
  }

  showText() {
    this.fullText = true;
    this.partialText = false;
  }

  partialText1() {
    this.fullText = false;
    this.partialText = true;
  }

  openDialog(singleObj) {
    this.showAll = !this.showAll;
    // this.setSelectedPlanDetails(singleObj);
  }

  removeScript(){
    $(".brevo-conversations__iframe-wrapper").remove();
    const existingScript = document.getElementById("ChatScript");

    if (existingScript) {
      // Remove the script element from the head tag
      document.getElementsByTagName('head')[0].removeChild(existingScript); 
    }
  }
}
